<template>
  <div class="evaluation-detail">
    <nav-bar
      fixed
      z-index="99"
      title="正在测评"
      left-text="返回"
      left-arrow
      placeholder
      @click-left="$router.go(-1)"
      right-text="个人中心"
      @click-right="$router.push('/user')"
    />
    <div class="evaluation-detail-title">
      {{ paperInfo.oneCateName }} - {{ paperInfo.paperName }} -
      {{ paperInfo.cateName }}
    </div>
    <div class="evaluation-detail-time">
      倒计时：
      <div>
        <CountDown
          :time="paperInfo.paperTime * 60 * 1000 || 1800000"
          @change="timeChange"
        />
      </div>
    </div>
    <div class="evaluation-detail-slider">
      <div class="evaluation-detail-slider-text">
        第{{ currentIndex + 1 }}/{{ paperList.length }}题
      </div>
      <Slider
        button-size="10"
        bar-height="8"
        disabled
        active-color="rgb(255,200,55)"
        inactive-color="#fff"
        v-model="currentIndex"
        :max="paperList.length - 1"
        @change="changeHandle"
        :step="1"
      />
    </div>
    <div class="evaluation-detail-content">
      <div class="evaluation-detail-content-detail">
        {{
          paperList[currentIndex].topicType == 0
            ? paperInfo.basicTip
            : paperInfo.paperTip
        }}
      </div>

      <div class="evaluation-detail-content-title">
        {{ currentIndex + 1 }}、{{ paperList[currentIndex].name }}
      </div>

      <Topic
        :index="currentIndex"
        :paperList="paperList"
        @chooseItem="chooseItem"
      />
    </div>

    <div class="evaluation-detail-btn">
      <div
        class="evaluation-detail-btn-submit"
        v-show="showSubmit"
        @click="submitHandle"
      >
        提交测评并查看报告
      </div>

      <div
        class="evaluation-detail-btn-pre"
        style="background-color: rgb(169, 178, 219)"
        v-show="showPre"
        @click="preHandle"
      >
        上一题
      </div>
      <div
        class="evaluation-detail-btn-pre"
        v-show="showNext"
        @click="nextHandleSubject()"
      >
        下一题
      </div>
      <!-- <div
        class="evaluation-detail-btn-pre"
        @click="nextHandle()"
      >
        下一题
      </div> -->
      <div
        class="evaluation-detail-btn-pre"
        v-show="showNextNotSubject"
        @click="nextNotSubject"
      >
        跳转到未作答题
      </div>
    </div>
  </div>
</template>

<script>
import { Slider, CountDown, NavBar } from "vant";
import { getPaperInfo, saveRecord } from "@/api/evaluation";
import Topic from "./components/topic.vue";
import localStorageTime from "@/utils/store/localStorageTime";

export default {
  components: {
    Slider,
    CountDown,
    Topic,
    NavBar,
  },
  data() {
    return {
      sliderValue: 0,
      time: 1800000,
      paperInfo: {},
      paperList: [],
      currentIndex: 0,
      showSubmit: false,
      showPre: false,
      showNext: false,
      // 剩余时间
      remainder: 0,
      userInfo: {},
      showNextNotSubject: false,
      // 当前选中的题目下的答案子项
      answerItem: {},
    };
  },
  mounted() {
    this.getPaperInfo();
    this.userInfo = this.$store.state.app.userInfo;
  },
  methods: {
    timeChange(time) {
      this.remainder =
        time.days * 24 * 60 * 60 +
        time.hours * 60 * 60 +
        time.minutes * 60 +
        time.seconds;
    },
    getPaperInfo() {
      const data = {
        orderId: this.$route.query.orderId,
      };
      getPaperInfo(data)
        .then((res) => {
          // 判断当前试卷是否已完成，已完成返回测评列表
          if (res.data.status == 2) {
            this.$toast("当前测评已完成");
            this.$router.push("/evaluation/my");
            return;
          }

          this.paperInfo = res.data;
          const paperList = [
            ...this.paperInfo.reviewTopicVOS,
            ...this.paperInfo.reviewTopicList,
          ];
          this.paperList = paperList.map((item) => {
            const content = {};
            item.answers.map((answer) => {
              content[answer.id] = {
                remark: "",
                ...answer,
              };
            });
            return {
              ...item,
              answerId: [],
              content: content,
              skip: false,
            };
          });

          this.getCacheData();
        })
        .catch((err) => {
          this.$toast(err.msg);
          setTimeout(() => {
            this.$router.push("/evaluation/choose");
          }, 2000);
        });
    },
    changeHandle() {},
    preHandle() {
      if (this.currentIndex > 0) {
        // this.currentIndex--;
        // 查找上一个未跳过的题目， 再把之间的题目的skip设置为false，
        for (let i = this.currentIndex - 1; i >= 0; i--) {
          if (!this.paperList[i].skip) {
            this.currentIndex = i;
            break;
          } else {
            // this.paperList[i].skip = false;
          }
        }
        this.showNextNotSubject = true;
      }
    },
    nextHandle(current = null) {
      const currentPaper = this.paperList[this.currentIndex];
      // 未选中按钮在的话，一题一题跳

      const isRequired = currentPaper.answers.some(
        (item) =>
          item.isRequired &&
          currentPaper.answerId.includes(item.id) &&
          !currentPaper.content[item.id].remark
      );
      if (isRequired) {
        this.$toast("请完整填写信息再进行下一题哦~");
        this.showNext = true;
        return;
      }
      // 判断当前题目是否有选中的选项
      if (currentPaper.answerId.length === 0) {
        this.$toast("请选择当前题目的答案");
        return;
      }

      if (this.currentIndex < this.paperList.length - 1) {
        this.$toast(`已完成第${this.currentIndex + 1}题，跳转到下一题`);
        setTimeout(() => {
          if (current !== null) {
            this.currentIndex = current;
            // this.saveCurrentData();
          } else {
            // 下面内容应该增加一个关联题跳转
            if (this.answerItem.topicNum) {
              // 跳转到关联题
              this.paperList.map((paper, index) => {
                if (paper.sort == this.answerItem.topicNum) {
                  // 当前sort相同的题目
                  const currentPaper = this.paperList.find(
                    (pitem) => this.answerItem.topicNum == pitem.sort
                  );
                  if (currentPaper.id == paper.id) {
                    // 将当前题和关联题之间的题目的skip设置为true
                    for (let i = this.currentIndex + 1; i < index; i++) {
                      this.paperList[i].skip = true;
                    }
                    console.log("这里跳转");
                    this.nextHandle(index);
                  }
                }
              });
              return;
            }
            // 跳转到下个未选中的题目
            for (
              let i = this.currentIndex + 1;
              i < this.paperList.length;
              i++
            ) {
              if (
                this.paperList[i].answerId.length === 0 &&
                !this.paperList[i].skip
              ) {
                console.log("跳转");
                this.nextHandle(i);
                return;
              }
            }
            // 全部选中了，跳转到最后一题
            this.nextHandle(this.paperList.length - 1);
            return;
          }
        }, 200);
      }
    },
    nextHandleSubject() {
      // 跳转到下个未选中的题目
      for (let i = this.currentIndex + 1; i < this.paperList.length; i++) {
        if (!this.paperList[i].skip) {
          this.nextHandle(i);
          this.showNextNotSubject = false;
          return;
        }
      }
    },
    // 提交题目
    submitHandle() {
      // console.log(this.paperList);
      // 整理数据
      const list = [];
      let data = {};

      // 校验是否为空， item.answerId.length == 0 说明没有选择答案
      // for (let i = 0; i < this.paperList.length; i++) {
      //   if (this.paperList[i].type == 0 && this.paperList[i].answerId.length == 0) {
      //     this.$toast("请完成所有题目")
      //     return
      //   }
      // }
      this.paperList.map((item) => {
        // 如果为单选题
        if (item.type == 0) {
          // 这里这样添加的原因是为了防止用户不选择答案，或者存在关联题跳转的情况
          item.answerId.length > 0 &&
            list.push({
              // 试卷ID
              paperId: this.paperInfo.id,
              // 题目ID
              topicId: item.id,
              // 答案ID
              answerId: item.answerId[0],
              // 填空内容
              remark: item.content[item.answerId[0]].remark || "",
              score: item.content[item.answerId[0]].score,
              // 题目类型
              topicType: item.topicType,
              topicName: item.content[item.answerId[0]].paperName,
              userId: this.userInfo.uid,
            });
        } else if (item.type == 1) {
          // 填空题
          item.answers.map((answer) => {
            list.push({
              // 试卷ID
              paperId: this.paperInfo.id,
              // 题目ID
              topicId: item.id,
              // 答案ID
              answerId: answer.id,
              // 填空内容
              remark: item.content[answer.id].remark,
              score: item.content[answer.id].score,
              // 题目类型
              topicType: item.topicType,
              topicName: item.content[answer.id].paperName,
              userId: this.userInfo.uid,
            });
          });
        } else if (item.type == 2) {
          // 多选题
          item.answerId.map((id) => {
            list.push({
              // 试卷ID
              paperId: this.paperInfo.id,
              // 题目ID
              topicId: item.id,
              // 答案ID
              answerId: id,
              // 填空内容
              remark: item.content[id].remark,
              score: item.content[id].score,
              // 题目类型
              topicType: item.topicType,
              topicName: item.content[id].paperName,
              userId: this.userInfo.uid,
            });
          });
        }
      });

      data = {
        orderId: this.$route.query.orderId,
        list: list,
        time: this.remainder,
      };

      saveRecord(data)
        .then((res) => {
          // console.log(res)
          this.$router.push({
            path: "/evaluation/result",
            query: {
              orderId: this.$route.query.orderId,
            },
          });
        })
        .catch((err) => {
          this.$toast(err.msg);
        });
    },
    // 选中了选项
    chooseItem(item) {
      this.answerItem = item;
      if (this.paperList[this.currentIndex].type == 2) {
        // 选中了多选题
        this.showNext = true;

        // 判断是否已经选择了答案，如果选择了就取消选择
        if (this.paperList[this.currentIndex].answerId.includes(item.id)) {
          this.paperList[this.currentIndex].answerId = this.paperList[
            this.currentIndex
          ].answerId.filter((id) => id !== item.id);
        } else {
          this.paperList[this.currentIndex].answerId.push(item.id);
        }
      } else {
        this.paperList[this.currentIndex].answerId = [item.id];
      }
      // 下面内容应该增加一个关联题跳转
      if (item.topicNum) {
        // 跳转到关联题
        this.paperList.map((paper, index) => {
          if (paper.sort == item.topicNum) {
            // 当前sort相同的题目
            const currentPaper = this.paperList.find(
              (pitem) => item.topicNum == pitem.sort
            );
            if (currentPaper.id == paper.id) {
              // 将当前题和关联题之间的题目的skip设置为true
              for (let i = this.currentIndex + 1; i < index; i++) {
                this.paperList[i].skip = true;
              }
              this.nextHandle(index);
            }
          }
        });
        return;
      }

      if (
        this.paperList[this.currentIndex].type == 0 &&
        !this.paperList[this.currentIndex].skip
      ) {
        // 直接跳转下一题
        // this.nextHandle();

        // 跳转到下个未选中的题目
        for (let i = this.currentIndex + 1; i < this.paperList.length; i++) {
          if (this.paperList[i].answerId.length === 0) {
            this.nextHandle(i);
            return;
          }
        }
        // 全部选中了，跳转到最后一题
        this.nextHandle(this.paperList.length - 1);
      }
    },
    // 未选中题
    nextNotSubject() {
      // 判断当前题目是否选中
      if (this.paperList[this.currentIndex].answerId.length === 0) {
        this.$toast("请选择当前题目的答案");
        return;
      }

      // 跳转到下个未选中的题目
      for (let i = this.currentIndex + 1; i < this.paperList.length; i++) {
        if (
          this.paperList[i].answerId.length === 0 &&
          !this.paperList[i].skip
        ) {
          this.nextHandle(i);
          this.showNextNotSubject = false;
          return;
        }
      }
      this.$toast("已经全部选完了哦~");
      this.nextHandle(this.paperList.length - 1);
      // this.showNextNotSubject = false;
    },
    // 保存当前试题数据，用于缓存
    saveCurrentData() {
      // 一周后
      const expires = new Date().getTime() + 7 * 24 * 60 * 60 * 1000;
      localStorageTime.set({
        name: "evaluation-" + this.$route.query.orderId,
        value: JSON.stringify(this.paperList),
        expires,
      });
    },
    // 判断是否做过，做过则从缓存中取出数据
    getCacheData() {
      const cacheData = localStorageTime.get(
        "evaluation-" + this.$route.query.orderId
      );
      if (cacheData && Object.keys(cacheData).length > 0) {
        this.paperList = JSON.parse(cacheData);
        this.showNextNotSubject = true;
        this.showNext = true;
      }
    },
  },
  watch: {
    currentIndex: {
      handler(val) {
        // 已经跳转到的当前题目，判断当前题目是否为skip，是的话取消
        if (this.paperList[val].skip) {
          this.paperList[val].skip = false;
        }

        if (this.currentIndex === this.paperList.length - 1) {
          this.showSubmit = true;
        } else {
          this.showSubmit = false;
        }
        if (this.currentIndex === 0) {
          this.showPre = false;
        } else {
          this.showPre = true;
        }
        if (this.currentIndex === this.paperList.length - 1) {
          // 最后一题
          this.showNext = false;
        } else if (this.paperList[val].type == 2) {
          this.showNext = true;
        } else {
          this.showNext = false;
          // 判断下一题是否做过
          for (let i = val + 1; i < this.paperList.length; i++) {
            if (this.paperList[i].answerId.length > 0) {
              console.log("下一题做过");
              // 下一题做过则显示下一题按钮
              this.showNext = true;
              break;
            }
          }
        }
        this.$nextTick(() => {
          this.saveCurrentData();
        });
      },
      // immediate: true,
      deep: true,
    },
  },
  destroyed() {
    // 退出当前页面触发
    // 判断是否做完题目，没做完进行缓存
    // alert("当前题目未做完，请保存！")
    this.saveCurrentData();
  },
};
</script>

<style scoped lang="scss">
.evaluation-detail {
  padding: 0.5rem 0.2rem;
  padding-bottom: 2.3rem;
  &-title {
    font-size: 0.3rem;
    font-weight: bold;
    font-family: DINAlternate-Bold;
    text-align: center;
    padding: 0.15rem 0;
    background-color: rgb(255, 200, 55);
    border-radius: 2rem;
    color: #000;
  }

  &-time {
    font-size: 0.25rem;
    color: #000;
    font-weight: bold;
    text-align: center;
    padding: 0.2rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &-slider {
    // padding: 0.2rem 0;
    display: flex;
    align-items: center;

    &-text {
      flex-shrink: 0;
      font-size: 0.25rem;
      color: #666;
      text-align: center;
      // padding: 0.1rem 0;
      margin-right: 0.2rem;
      color: #000;
    }
  }

  &-content {
    padding: 0.2rem 0;

    &-detail {
      font-size: 0.25rem;
      color: #666;
      padding: 0.2rem 0;
    }

    &-title {
      font-size: 0.28rem;
      color: #111;
      // padding: 0.2rem 0;
      font-weight: bold;
    }

    &-list {
      &-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 0.02rem solid #666;
        border-radius: 0.1rem;
        font-size: 0.25rem;
        color: #666;
        padding: 0.2rem 0.3rem;
        margin: 0.4rem 0;

        &-text {
          font-size: 0.25rem;
          color: #000;
        }

        &-radio {
          width: 0.3rem;
          height: 0.3rem;
          border-radius: 50%;
          border: 1px solid #000;
        }
      }

      .active {
        background-color: rgb(254, 248, 232);

        .evaluation-detail-content-list-item-radio {
          background-color: rgb(255, 200, 55);
        }
      }
    }
  }

  &-btn {
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    // align-items: center;
    font-weight: bold;
    // 固定在底部
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    &-pre {
      font-size: 0.25rem;
      margin: 5px 0;
      color: #fff;
      padding: 0.2rem 0.3rem;
      border-radius: 2rem;
      background-color: rgb(98, 197, 157);
      text-align: center;

      box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.5);
      border: 2px solid #ccc;
    }

    &-submit {
      border-radius: 2rem;
      font-size: 0.25rem;
      color: #666;
      padding: 0.2rem 0.3rem;
      background-color: rgb(255, 200, 55);
      text-align: center;
      margin-top: 0.3rem;

      box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.5);
      border: 2px solid #ccc;
    }
  }
}

::v-deep .van-slider {
  border: 1px solid rgb(255, 200, 55);

  &__button {
    background-color: rgb(104, 196, 158);
  }

  &--disabled {
    opacity: 1;
  }
}

::v-deep .van-nav-bar {
  background-color: rgb(255, 200, 55) !important;
}
</style>
